module.exports = __webpack_public_path__ + "fonts/font.4b7fa47.woff2";